import { ChevronDown, ChevronRight } from 'react-feather';

export default function OrderInstallerSection({
    register,
    installers,
    sections,
    toggleSection
}) {
    return (
        <div className="tab-information">
            <div className="tab-information-block">
                <div
                    className="title-block"
                    onClick={(e) => toggleSection('installerTab', e)}
                >
                    <h2 className="title-h2">Installer</h2>
                    <button type="button">
                        {sections.installerTab ? (
                            <ChevronDown size={24} />
                        ) : (
                            <ChevronRight size={24} />
                        )}
                    </button>
                </div>
                {sections.installerTab && (
                    <div className="new-order-form">
                        <div className="field-section-full">
                            <div className="inp-col installer-dropdown">
                                <label htmlFor="installerId">
                                    <strong>Assign an installer</strong>
                                </label>
                                <select {...register('installerId')}>
                                    <option value="">Select installer</option>
                                    {installers?.map((installer) => (
                                        <option key={installer.id} value={installer.id}>
                                            {installer?.firstName} {installer?.lastName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
